export interface AiConfiguration {
  id: string;
  model_name: string;
  system_prompt: string;
  temperature?: number;
  cost_per_1M_tokens?: number;
  max_tokens?: number;
  created_at?: string;
  updated_at?: string;
  is_active?: boolean;
}

export interface AiTestResult {
  id?: string;
  ai_configuration_id: string;
  user_input: string;
  input_number: number;
  gpt_response?: string;
  response_time?: number;
  created_at?: string;
}

export interface TestResponse {
  inputNumber: number;
  response: string;
  responseTime: number;
}

export const RULES_SNIPPET: string = `Ausgabeformat:
- Antworte ausschließlich mit einem HTML-Snippet (ohne <html>, <head> oder <body>).
- Erlaubte Tags: <p>, <br>, <ul>, <ol>, <li>, <strong>, <em>, <span>.
- Erlaubte Inline-Styles nur auf <span> mit "color" oder "background-color" (z. B. #RRGGBB oder red/green/blue/orange/gray/black/yellow).
- Entferne oder escape alle nicht erlaubten Tags.

  Struktur:
- Verwende <ol> für Schritte oder Reihenfolgen, <ul> für Aufzählungen.
- Teile lange Sätze in kürzere Einheiten.
- Vermeide Wiederholungen.
- Nutze <strong> und <em> sparsam für Hervorhebungen.

  Wichtig:
- Keine Überschriften, keine Zusatztexte, keine Meta-Erklärungen.
- Gib nur das formatierte HTML-Snippet zurück.
  `.trim();
